import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { GuardJobDetails } from '../../../../../types';
import { ApiClient } from '../../../../api-client';
import { UnitResult } from '../../../../error';
import { GetGuardJobDetails } from '../../../Domain/Port/GetGuardJobDetails/get-guard-job.details';

@Injectable({
    providedIn: 'root'
})
export class BackendGetGuardJobDetailsService extends GetGuardJobDetails {
    constructor(private apiClient: ApiClient) {
        super();
    }

    override execute(id: number): Observable<UnitResult<GuardJobDetails>> {
        return this.apiClient.get<GuardJobDetails>(`/jobs/${id}`, true);
    }
}
